import { useTranslation } from "react-i18next";

import { FieldRichText } from "@/ui/field-rich-text";
import { FieldText } from "@/ui/field-text";

export const EditorLabelFields = () => {
  const { t } = useTranslation();

  return (
    <>
      <FieldRichText name="label" label={t(`schema:property.label`)} required />
      <FieldText name="model" label={t(`schema:property.model`)} hidden />
    </>
  );
};
